import {useLocation} from 'react-router-dom'

import Footer from '../components/Footer/Footer'
import Header from '../components/Header/Header'

const BaseLayout = ({children}) => {
  const location = useLocation()
  const contentId = location.pathname.replace(/\//g, '')

  return (
    <>
      <Header />

      <div id={contentId ? `content-${contentId}` : 'content-home'} className="content">
        {children}
      </div>

      <Footer />
    </>
  )
}

export default BaseLayout
